"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactDdl = require("@americanexpress/react-ddl");

var _utils = require("../utils");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AmexDDLRegister = function AmexDDLRegister(_ref) {
  var disableRegisterList = _ref.disableRegisterList;

  /* istanbul ignore next */
  var _useDDL = (0, _reactDdl.useDDL)(),
      _useDDL$updateDDL = _useDDL.updateDDL,
      updateDDL = _useDDL$updateDDL === void 0 ? function () {} : _useDDL$updateDDL,
      subscribe = _useDDL.subscribe;

  (0, _react.useEffect)(function () {
    // The following digitalDataHandlers logic should be removed before official release
    var count = 0;
    window.digitalDataHandlers = [];

    window.digitalDataHandlers.push = function (handler) {
      subscribe({
        subscriber: "".concat(count),
        handler: handler
      });
      count += 1;
    };

    if (process.env.NODE_ENV === 'development') {
      // Dynamic import excludes 'tv4' dependency from production bundle
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('../localValidator'));
      }).then(function (_ref2) {
        var localValidator = _ref2.localValidator;
        subscribe({
          subscriber: 'DigitalDataValidator',
          handler: localValidator
        });
      });
    } // If user set view to true in disableRegisterList, don't track.


    if (!disableRegisterList.view) {
      updateDDL({
        name: 'view',
        value: (0, _utils.getViewInfo)(window.location.pathname)
      });
      var _global = global,
          history = _global.history;
      ['pushState', 'replaceState'].forEach(function (stateEdit) {
        var orig = history[stateEdit];

        if (typeof orig !== 'function') {
          return;
        }
        /* eslint-disable-next-line func-names */


        history[stateEdit] = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          updateDDL({
            name: 'view',
            value: (0, _utils.getViewInfo)(args[2])
          });
          return orig.apply(this, args);
        };
      });
    }
  }, []);
  var charset = disableRegisterList.charset,
      visitorId = disableRegisterList.visitorId,
      device = disableRegisterList.device;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !charset ? /*#__PURE__*/_react.default.createElement(_reactDdl.DDLRegister, {
    name: "charset",
    value: global.window && window.document && window.document.charset
  }) : null, !visitorId ? /*#__PURE__*/_react.default.createElement(_reactDdl.DDLRegister, {
    name: "user.visitorId",
    value: (0, _utils.getVisitorId)()
  }) : null, !device ? /*#__PURE__*/_react.default.createElement(_reactDdl.DDLRegister, {
    name: "device",
    value: (0, _utils.getDevice)()
  }) : null);
};

AmexDDLRegister.propTypes = {
  disableRegisterList: (0, _propTypes.shape)({
    view: _propTypes.bool,
    charset: _propTypes.bool,
    visitorId: _propTypes.bool,
    device: _propTypes.bool
  })
};
AmexDDLRegister.defaultProps = {
  disableRegisterList: {}
};
var _default = AmexDDLRegister;
exports.default = _default;